import { Skeleton } from "@mui/material";
import { useState } from "react";
import MailsTable from "../mails/table";
import { collection, getCountFromServer, getDocs, limit, orderBy, query } from "firebase/firestore";
import { db } from "../../firebase/firebase";
import { Mail } from "../../classes/mail.tsx";
import { Margin } from "../small-widgets.jsx";
import { OpenInNewOutlined } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export default function HomeMails() {
    const { t } = useTranslation();
    const navigate = useNavigate();

    const [lastMails, setLastMails] = useState(null);
    const [totalMails, setTotalMails] = useState(null);

    async function getLastMails() {
        const newMails = [];
        const lastMails = await getDocs(query(collection(db, 'mail'), orderBy('delivery', 'desc'), limit(10)));
        lastMails.docs.forEach(doc => {
            const newMail = Mail.fromJson(doc.data(), doc.id);
            console.log(newMail);
            newMails.push(newMail);
        })

        const count = await getCountFromServer(collection(db, 'mail'));
        setTotalMails(count.data().count);
        setLastMails(newMails);
    }

    if (lastMails === null || totalMails === null) {
        getLastMails();
        return <Skeleton variant="rounded" width={'100%'} height={200} />;
    }

    return <div>
        {lastMails.length === 0
            ? <div>
                <div>{t('mails.noMails')}</div>
            </div>
            : <>
                <div>{t('homePage.mails.desc.start')} <span className="black">{lastMails.length}</span> {t('homePage.mails.desc.end')} <span className="black">{totalMails}</span> {t('homePage.mails.desc.totalMails')} <span><a href={`/mails`}>{t('homePage.mails.desc.viewAll')} <span><OpenInNewOutlined style={{transform: 'translate(0px, 5px)', fontSize: '15pt'}}/></span></a></span></div>
                <Margin height={10}/>
                <MailsTable mails={lastMails} onClick={(mail) => {navigate(`/mails/details?id=${mail.getId()}`)}}/>
            </>
        }
    </div>;
}